import { ref, shallowRef } from 'vue'

export function useFetch<T>(fetchFn: () => Promise<T>) {
  const data = shallowRef<T | null>(null)
  const error = ref(false)
  const loading = ref(false)

  async function execute() {
    try {
      loading.value = true
      data.value = await fetchFn()
      error.value = false
    } catch {
      error.value = true
    } finally {
      loading.value = false
    }
  }

  execute()

  return {
    data,
    error,
    loading,
    retry: execute
  }
}
